import client from '../httpClient';

const sendmailCancelApi = (params) => {
  return client.post('/send-mails/cancel/', params, { isShowMessage: true });
};

export default sendmailCancelApi;
